<template>
    <router-link
            :to="{...$route, name:item.to}"
            class="sharing-panel-item"
            :class="{'sharing-panel-item_active': item.active}"
            style="text-decoration: none;"
            :aria-label="item.label"
    >
        <div class="sharing-panel-item__icon" :class="item.iconClass">
            <span class="sharing-panel-item__icon-counter">{{ item.count }}</span>
            <span class="sharing-panel-item__icon-new-marker" v-if="item.hasNew">NEW</span>
        </div>
        <div class="sharing-panel-item__text">
            {{ item.label }}
        </div>
    </router-link>
</template>

<script>
    export default {
        name: "GroupPageMenuSharingPanelItem",
        props: {
            item: Object,
        }
    };
</script>

<style scoped lang="scss">
  @import "../../styles/const";
  @import "../../styles/mixins";

  .sharing-panel-item {
    display: inline-block;
    margin: 7px;

    $cs: &;

    &_active {
      font-weight: bolder;
    }

    &:focus {
      #{$cs}__icon {
        box-shadow: 0 0 3px 3px rgba(255, 255, 255, 0.7);
      }

      #{$cs}__text {
        font-weight: bold;
      }
    }

    &__icon {
      position: relative;
      overflow: visible;
      width: 65px;
      height: 65px;
      border-radius: 50%;
      background-color: white;
      background-repeat: no-repeat;
      background-position: center;
      background-size: 42px 42px;
      cursor: pointer;

      &.stories {
        background-image: url('./icons/stories.png');
      }

      &.wiki {
        background-image: url('./icons/wiki.png');
      }

      &.media {
        background-image: url('./icons/media-folder.png');
      }
    }

    &__icon-counter {
      z-index: 1;
      width: 25px;
      height: 25px;
      border-radius: 50%;
      color: white;
      text-align: center;
      background-color: #03538e;
      position: absolute;
      top: -3px;
      right: -2px;
      line-height: 25px;
    }

    &__icon-new-marker {
      position: absolute;
      top: -3px;
      left: 2px;
      width: 25px;
      height: 25px;
      line-height: 25px;
      color: #fff;
      text-align: center;
      font-size: 10px;
      background-color: $grass-green;
      border-radius: 50%;
      background-size: cover;
    }

    &__text {
      margin-top: 5px;
      color: white;
      text-align: center;
    }
  }
</style>